import { Component } from '@angular/core';
import { SuccessMessageService } from '../succuss-response-shared.component.service';
import { AuthSessionService } from 'src/app/shared/service/disbursment/auth-session.service';

@Component({
  selector: 'app-pa-form-submit-success-page',
  templateUrl: './pa-form-submit-success-page.component.html',
  styleUrls: ['./pa-form-submit-success-page.component.scss']
})
export class PaFormSubmitSuccessPageComponent {
successMessage: string = '';

  constructor(
    private successMessageService: SuccessMessageService, private authSessionService: AuthSessionService
  ) { }

  ngOnInit(): void {
    this.successMessageService.successMessage$.subscribe((message) => {
      this.successMessage =
        message ||
        "Thank you for your submission. We have received your information and will process it shortly.";
    });

    this.authSessionService.clearSessionOwner();

    window.addEventListener('popstate', this.handleBackNavigation);
  }

  private handleBackNavigation = () => {
    this.authSessionService.exitDisbursementMode();
    this.authSessionService.clearSessionOwner();
    sessionStorage.clear();
    localStorage.clear();
    location.replace('/login');
  };

  ngOnDestroy(): void {
    window.removeEventListener('popstate', this.handleBackNavigation);
  }
}
